import styled from "styled-components";
import PrevIcon from "assets/icons/FilterIcon/calender-prev-icon.png";
import NextIcon from "assets/icons/FilterIcon/calender-next-icon.png";
import CalanderIcon from "assets/icons/calendar-icon.png";
export const CalanderWrapper = styled.div`
  /* margin-bottom: 16px; */
  .react-calendar__month-view__days__day--neighboringMonth {
    color: white;
    visibility: hidden;
  }
  .react-calendar {
    width: 270px;
    margin: 0 auto;
    max-width: 100%;
    background: #ffffff80;
    border: none;
    margin: 0 auto;
    padding: 0 9px;
    font-family: inherit;
    margin-bottom: 26px;
    .react-calendar__navigation__prev2-button,
    .react-calendar__navigation__next2-button {
      display: none;
    }

    .react-calendar__navigation__next-button {
      position: relative;
      ::after {
        content: url(${NextIcon});
        display: inline-block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #f9fbfd;
      }
      :hover {
        ::after {
          background-color: #d5e3e9;
        }
      }
    }
    .react-calendar__navigation__prev-button {
      position: relative;
      ::after {
        content: url(${PrevIcon});
        display: inline-block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #f9fbfd;
      }
      :hover {
        ::after {
          background-color: #d5e3e9;
        }
      }
    }
    .react-calendar__navigation__label {
      :hover {
        background-color: #d5e3e9;
      }
    }
    .react-calendar__month-view__weekdays {
      gap: 2px;
      justify-content: space-between;
      margin-bottom: 15px;
    }
    .react-calendar__month-view__weekdays__weekday {
      background: #e5e5e5;
      border-radius: 4px;
      max-width: 31px;
      abbr {
        text-decoration: none;
      }
    }
    .react-calendar__tile {
      padding: 9px;
      font-family: "latobold";
    }
    /* .react-calendar__month-view__weekdays {
      > div {
        :last-child,
        :nth-last-child(2) {
          color: #ff4949;
        }
      }
    } */
    .react-calendar__month-view__days__day--weekend,
    .koNDSU .react-calendar .react-calendar__tile {
    }
    span.react-calendar__navigation__label__labelText.react-calendar__navigation__label__labelText--from {
      text-transform: uppercase;
    }
    .react-calendar__month-view__days__day--weekend {
      color: var(--text-primary);
    }
    .react-calendar__tile--active {
      background: var(--theme-background);
      color: var(--theme-text);
      font-size: 14px;
      border-radius: 50%;
    }
    .react-calendar__tile--now {
      border-radius: 50%;
    }
  }
`;

export const StyledTable = styled.div`
  /* max-height: calc(100vh - 287px);
    overflow: auto; */
  width: 100%;
  .action-icon-btn {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  table {
    width: 100%;
    text-align: left;
    border-collapse: separate;
    border-spacing: 0 4px;
  }
  .table-head {
    font-weight: 700;
    font-size: 13px;
    line-height: 150.5%;
    text-transform: uppercase;
    th {
      padding: 17px 10px;
      font-size: 14px;
      position: sticky;
      background-color: var(--inner-section-bg);
      z-index: 1;
      font-weight: 500;
      top: 0;
      :first-child {
        padding-left: 30px;
      }
      :last-child {
        padding-right: 30px;
      }
    }
  }
  .flex-wrapper-icon {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .w-100 {
    width: 100%;
  }
  .body {
    font-size: 16px;
    background: #ffffff;
    box-shadow: 0px 2px 5px rgb(0 0 0 / 10%);
    .green-text {
      color: #00a692;
    }
    .red-text {
      color: #fa3c30;
    }

    .gray-text {
      color: #aeaeae;
    }
    .bold {
      font-weight: 700;
    }
    .round-btn {
      font-size: 13px;
      height: 30px;
      display: flex;
      align-items: center;
      gap: 8.5px;
      border-radius: 30px;
      background-color: transparent;
      border: 1px solid #636f7c;
      padding: 0 10px;
      white-space: nowrap;
    }
    td {
      padding: 12px 10px;
      font-size: 14px;
      :first-child {
        padding-left: 30px;
      }
      :last-child {
        padding-right: 30px;
      }
    }
  }
  .MuiTableCell-head {
    color: #000;
    font-family: inherit;
    font-weight: 700;
    text-transform: uppercase;
  }
  @media (max-width: 850px) {
    .table-head {
      .display {
        display: none;
      }
      th {
        padding: 9px 10px;
        font-size: 12px;
        :first-child {
          padding-left: 10px;
        }
      }
    }
    .body {
      .display {
        display: none;
      }
      td {
        padding: 8px 10px;
        font-size: 12px;

        :first-child {
          padding-left: 10px;
        }
      }
    }
  }
`;

export const CircleBtn = styled.button`
  height: 31px;
  border: 1px solid var(--border-color);
  border-radius: 30px;
  font-size: 12px;
  line-height: 150.5%;
  background-color: transparent;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  &.pointer-event-none {
    pointer-events: none;
  }
  :disabled {
    opacity: 0.65;
    cursor: default;
    /* pointer-events: none; */
  }
  &.active {
    background: #bc9b6a;
    color: #fff;
    border-color: transparent;
  }
  /* cursor: pointer;
  font-family: "latoregular"; */
`;

export const AccordionStyled = styled.div`
  > .MuiPaper-root {
    box-shadow: none;
    margin-bottom: 15px;
    .tab-container {
      .MuiTabPanel-root {
        padding: 24px 0;
      }
    }
    > .MuiAccordionSummary-root {
      padding: 0 28px;
      background: var(--box-header-background);
      border: var(--box-header-border);
    }
    .MuiAccordionDetails-root {
      padding: 0;
    }

    .MuiAccordionSummary-content {
      margin: 13px 0;
      h3 {
        font-weight: 700;
        font-size: 16px;
        line-height: 31px;
        color: #000000;
      }
    }
    .MuiAccordionSummary-root.Mui-expanded {
      min-height: 60px;
    }
    .MuiAccordionSummary-content.Mui-expanded {
      margin: 13px 0;
    }
  }
  /* @media (max-width: 850px) {
    margin-top: 10px;
  } */
`;

export const ToggleSwitch = styled.div`
  .MuiSwitch-root .MuiSwitch-switchBase {
    padding: 1px;
  }
  .MuiSwitch-root .MuiSwitch-switchBase.Mui-checked {
    color: #00a692;
    .MuiSwitch-thumb,
    + .MuiSwitch-track {
      background-color: #00a692;
    }
  }

  .MuiSwitch-root .MuiSwitch-thumb {
    background-color: #92acb7;
    border: 3px solid #f2f6fa;
    box-shadow: none;
    width: 20px;
    height: 20px;
  }
  .MuiSwitch-track {
    background: #92acb7;
    opacity: 1;
    height: 8px;
    width: 92%;
  }
`;

export const PopUpContainer = styled.div`
  /* background-color: red; */
  /* padding: 27px 27px 32.5px 27px; */
  padding-bottom: 32px;
  &.missing-data-popup {
    padding-bottom: 20px;
    .missing-data-popup-container {
      > div {
        max-height: calc(100vh - 300px);
        overflow: auto;
        margin-bottom: 20px;
        /* padding: 0 20px; */
        background-color: #f4f4d4;
        > div {
          padding: 7px 20px;
          :nth-child(odd) {
            background: #ffffff80;
            margin: 5px 0;
          }
        }
      }
    }
  }
  button {
    display: flex;
    align-items: center;
    gap: 7px;
    justify-content: center;
    &.publish-car {
      width: 100%;
    }
    text-transform: initial;
  }
  /* &.active {
    background: #bc9b6a;
    color: #fff;
    border-color: transparent;
  }  */
  /* &.send-data-btn {
      background: var(--theme-background);
      border: none;
      border-radius: 6px;
      color: var(--theme-text);
      font-size: 13px;
      line-height: 150.5%;
      height: 30px;
      padding: 0 6px;
    }
    &.deactive {
      background: #837f7f;
    } */
  //}

  .upload-btn-wrapper {
    position: relative;
    overflow: hidden;
    display: inline-block;
    .btn {
      border: 2px solid gray;
      color: gray;
      background-color: white;
      padding: 8px 20px;
      border-radius: 8px;
      font-size: 20px;
      font-weight: bold;
    }
    input[type="file"] {
      font-size: 100px;
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
    }
  }
  &.py-30 {
    padding-inline: 30px;
  }
  #theValidationData {
    overflow: auto;
    max-height: 400px;
    min-height: 200px;
  }

  h4 {
    text-align: center;
    padding: 32px 15px;
  }
  .header {
    padding: 11px 20px;
    display: flex;
    align-items: flex-start;
    background: var(--filter-bar-bg);
    font-size: 14px;
    line-height: 150.5%;
    color: #fff;
    font-family: "latobold";
  }
  h2 {
    font-size: 24px;
    line-height: 150.5%;
    text-align: center;
    margin-bottom: 30px;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 500;
    padding-top: 15px;
  }

  p {
    font-size: 14px;
    line-height: 150.5%;
    text-align: center;
    margin-bottom: 30px;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 500;
  }
  .cancel {
    float: right;
  }
  .crossbutton {
    float: right;
    margin-top: -26px;
    margin-right: -27px;
  }
  .correct {
    padding: 10px;
  }
  .next {
    float: right;
  }
  .correct1 {
    font-size: 20px;
  }
  .yes {
    background-color: #bc9b6a;
    margin-right: 5px;
  }
  .no {
  }
  .action-btn-align{
    justify-content: right !important;
    gap: 135px !important;
  }
  .addnew-img-btns{
    display: flex;
    gap:10px !important;
  }
  .txt-align{
    padding-left:80px;
    padding-right:80px;
  }
  .action-btn {
    display: flex;
    gap: 7px;
    justify-content: center;
    button {
      height: 41px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 103px;
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.05);
      border-radius: 30px;
      border: none;
      border: 1px solid #636f7c;
      border-radius: 30px;
      color: #1d1d1d;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      font-weight: 500;
      background: #fff;
      text-transform: initial;
      &.primary {
        background-color: var(--theme-background);
        color: var(--theme-text);
        border-color: transparent;
      }
      &.MuiButton-root.Mui-disabled {
        pointer-events: auto;
        color: rgba(0, 0, 0, 0.26);
      }

      &.active {
        background: #bc9b6a;
        color: #fff;
        border-color: transparent;
      }
      :disabled {
        opacity: 0.65;
        cursor: default;
      }
    }
  }
  .modal-body {
    padding: 10px 29px;
    .input-wrapper {
      margin-bottom: 18px;
      p {
        font-size: 13px;
        line-height: 150.5%;
        color: #000;
        margin-bottom: 10px;
        text-align: left;
      }
      input {
        background: #ffffff;
        border: 1px solid #cdcfd0;
        border-radius: 6px;
        max-width: 344px;
        width: 100%;
        height: 26px;
        margin-bottom: 14px;
        padding: 0 8px;
      }
      .des {
        color: #636f7c;
        font-size: 12px;
      }
    }
  }
`;
export const ModalHeader = styled.div`
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 43px;
  border-bottom: 1px solid #cccccc;
  h2 {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 150.5%;
    color: #000;
  }
`;
export const DatePickerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
  width: 100%;

  /* margin: 10px 15px; */
  .MuiBox-root {
    background: #ffffff;
    border: 1px solid #cdcfd0;
    border-radius: 6px;
    height: 30px;
    padding: 0 10px;
    max-width: 150px;
    input {
      border: none;
      width: 100%;
    }
    input:focus,
    textarea:focus,
    select:focus {
      outline: none;
    }
    .MuiButtonBase-root {
      width: 14px;
      height: 16px;
      padding: 0;
      background-image: url(${CalanderIcon});
      margin-right: 0px;
      border-radius: 0;
      svg {
        display: none;
      }
    }
  }
  .label-wrapper {
    display: flex;
    align-items: center;
    gap: 11px;
    width: 100%;
    color: var(--theme-text);
    .label {
      font-size: 13px;
      line-height: 150.5%;
      color: var(--theme-text);
    }
  }
`;
export const UploadBtnWrapper = styled.div`
  background: var(--input-background);
  border: 1px solid #cdcfd0;
  border-radius: 6px;
  display: flex;
  min-height: 22px;
  min-width: 80%;
  input[type="file"]::file-selector-button {
    margin-right: 20px;
    border: none;
    background: #bc9b6a;
    border-radius: 6px;
    padding: 10px 20px;
    color: #fff;
    cursor: pointer;
    transition: background 0.2s ease-in-out;
  }
  input {
    width: 100%;
  }
`;
export const TableContainer = styled.div`
  .MuiDataGrid-root {
    border: none;
  }
  .MuiDataGrid-row {
    background: var(--inner-section-bg);
    border: 1px solid var(--table-row-border-color);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    margin-bottom: 5px;
    .MuiDataGrid-cell {
      border: none;
      font-weight: 500;
    }
  }
  &.no-pagination {
    .MuiDataGrid-footerContainer {
      display: none !important;
    }
  }
  /* .MuiDataGrid-columnHeaderTitleContainerContent {
    .MuiButtonBase-root {
      padding: 9px 27px;
    }
  } */
  /* .MuiDataGrid-columnHeaderCheckbox,
  .MuiDataGrid-cellCheckbox {
    height: auto !important;
    width: auto !important;
    min-width: unset !important;
    max-width: unset !important;
  } */
  /* .MuiCheckbox-root {
    padding: 9px 27px;
  } */
  .MuiDataGrid-columnHeaders {
    border: none !important;
  }
  .MuiDataGrid-columnSeparator {
    display: none;
  }
  .MuiButtonBase-root {
  }
  .MuiCheckbox-root {
    .MuiSvgIcon-root {
      path {
        color: var(--table-un-check-color);
      }
    }
  }
  .Mui-checked {
    .MuiSvgIcon-root {
      path {
        color: var(--theme-background);
      }
    }
  }
  /* .MuiDataGrid-columnHeaders {
    margin-top: 12px;
  }
  .MuiDataGrid-virtualScrollerContent {
    margin-top: 5px;
  } */
  @media (max-width: 850px) {
    .MuiDataGrid-columnHeaderTitleContainerContent {
      .MuiButtonBase-root {
        padding: 9px 0;
      }
    }
    .MuiDataGrid-columnHeader.MuiDataGrid-columnHeader--sortable.lastcolumnSeparator.flex-1 {
      width: 100% !important;
      max-width: 100% !important;
    }
    .MuiDataGrid-columnHeader.MuiDataGrid-columnHeader--sortable.lastcolumnSeparator {
      font-weight: 700;
      font-size: 12px;
      line-height: 150.5%;
    }
    .MuiDataGrid-row {
      .MuiDataGrid-cell {
        font-size: 12px;
      }
    }
    .MuiDataGrid-virtualScrollerContent,
    .MuiDataGrid-virtualScrollerRenderZone {
      width: 100% !important;
    }
    .MuiDataGrid-row {
      width: 100% !important;
    }
    .MuiDataGrid-columnHeadersInner {
      width: 100%;
      > div {
        width: 100%;
      }
    }
  }
`;

export const BodyWrapper = styled.div`
  padding: 0 28px;
  @media (max-width: 850px) {
    padding: 0 15px;
  }
`;

export const DateRangePickerWrapper = styled.div`
  .label {
    font-size: 13px;
    line-height: 150.5%;
    color: #fff;
  }
  .MuiInputBase-root {
    max-width: 150px;
    background: #ffffff;
    border-radius: 6px;
  }
  .MuiInputBase-input {
    font-size: 13px;
    line-height: 150%;
    padding: 6px 10px;
  }
`;

export const CarDetailsModalWrapper = styled.div`
  position: fixed;
  max-width: 420px;
  background-color: #ffffff;
  bottom: 0;
  right: 0;
  height: 100%;
  border: none;
  width: 100%;
  @media (max-width: 550px) {
    max-width: 100%;
  }
`;

export const MobileHeader = styled.div`
  display: none;

  @media (max-width: 850px) {
    min-height: 56px;
    background: linear-gradient(180deg, #6b5c4b 0%, #31281d 4.4%);
    border: 1px solid #6a5742;
    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.05);
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    align-items: center;
    width: 100%;
    position: relative;
    h4 {
      font-weight: 900;
      font-size: 16px;
      line-height: 19px;
      color: #ffffff;
    }
    .open-section {
      position: absolute;
      right: 0;
      top: 55px;
      display: flex;
      flex-direction: column;
      gap: 15px;
      padding: 15px;
      border-radius: 6px;
      align-items: flex-end;
      background: linear-gradient(180deg, #6b5c4b 0%, #31281d 4.4%);
      z-index: 2;
    }
  }
`;

export const DialogContainer = styled.div`
  /* max-width: 400px; */
  padding-bottom: 32px;
  padding-right: 20px;
  padding-left: 20px;
  .header {
    font-size: 24px;
    line-height: 150.5%;
    text-align: center;
    margin-bottom: 30px;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 500;
    padding-top: 15px;
  }
  .content {
    font-size: 14px;
    line-height: 150.5%;
    text-align: center;
    margin-bottom: 30px;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 500;
    /* p {
      color: #000;
      font-size: 18px;
    } */
  }
  .action-wrapper {
    padding: 0 15px;
    gap: 7px;
    justify-content: center;

    button {
      min-width: 103px;
      padding: 0 15px;
      height: 41px;
      font-weight: 700;
      font-size: 14px;
      line-height: 150.5%;
      border: 1px solid #636f7c;
      border-radius: 30px;
      color: #1d1d1d;
      text-transform: initial;
      margin: 0;
      :nth-child(1) {
        background: #bc9b6a;
        color: #fff;
        border-color: transparent;
      }
    }
  }
`;
